import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { entAnimations } from 'src/app/animations';
import { RouteStatusService } from 'src/app/services/maintenance/route-status.service';
import { KeycloakService } from 'src/app/services/keycloak/keycloak.service';
import { EntNavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-assistance',
  templateUrl: './assistance.component.html',
  styleUrl: './assistance.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AssistanceComponent implements OnInit {
  readonly panelOpenState = signal(false);
  isLogin = false;
  isFormOpened = false;

  isTicketingDisabled = false;
  private subscription: Subscription = new Subscription();

  constructor(
    protected _translateService: TranslateService,
    _keycloakService: KeycloakService,
    private _navigationService: EntNavigationService,
    private _routeStatusService: RouteStatusService
  ) {
    this.isLogin = _keycloakService.isAuthenticated();
  }

  ngOnInit(): void {
    //Maintenance mode settings
    const urls = ['/ticket'];
    this.subscription.add(
      this._routeStatusService
        .getRouteStatusForUrls(urls)
        .subscribe(statuses => {
          this.isTicketingDisabled = statuses['/ticket'];
        })
    );
  }

  redirectServiceNow() {
    this._navigationService.redirectToServiceNow();
  }

  public redirectToSupport(): void {
    this._navigationService.redirectToSupport(
      this._translateService.currentLang
    );
  }

  activeTileIndex = 0; // Default active tile index

  setActiveTile(index: number): void {
    this.activeTileIndex = index;
  }

  actionForm(open) {
    this.isFormOpened = open;
  }

  openForms() {
    this.isFormOpened = true;
  }
}
